<template>
  <div class="business">
    <div class="nwrap">
      <div class="nei_ban">
        <h3>{{$t('m.business')}}<p></p>
        </h3>
      </div>
      <div class="clear ptb3"></div>
      <div class="mainbox wrap">
        <div class="fwList" v-if="$i18n.locale == 'zh-CN'">
          <ul>
            <li class="fl" v-for="(item, index) in businessList" :key="index">
              <a :href="`/listPic/${item.entTChannelUuid}`">
                <img :src="item.fileName" >
                <div class="fwtxt">
                  <b>{{item.name}}</b>
                  <span></span>
                  <p>{{item.name}}</p>
                </div>
              </a>
            </li>
            <div class="clear"></div>
          </ul>
        </div>
        <div class="fwList" v-if="$i18n.locale == 'en-US'">
          <ul>
            <li class="fl" v-for="(item, index) in businessListEn" :key="index">
              <a :href="`/listPic/${item.entTChannelUuid}`">
                <img :src="item.fileName" >
                <div class="fwtxt">
                  <b>{{item.name}}</b>
                  <span></span>
                  <p>{{item.name}}</p>
                </div>
              </a>
            </li>
            <div class="clear"></div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getChildChannel  } from '@/api/common'
export default {
  name: 'list',
  data(){
    return {
      businessList:[],
      businessListEn:[],
    }
  },
  mounted(){
    var _this = this
    _this.special()
  },
  methods: {
    special(){
      var _this = this
      let data3 = {
        applicationUuid: _this.webId,
        parentUuid: '0198'
      }
      getChildChannel(data3).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.businessList = data
        }
      })

      let data1 = {
        applicationUuid: _this.webIdEn,
        parentUuid: '0207'
      }
      getChildChannel(data1).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.businessListEn = data
        }
      })

    }

  }
}
</script>
<style lang="css" scoped>
.business .nei_ban {
  clear: both;
  width: 100%;
  height: 270px;
  background: url(../assets/image/1-200429120106245.jpeg );
}
.business .nei_ban {
  background-size: cover!important;
}
.business .nei_ban h3 {
  text-align: center;
  width: 100%;
  clear: both;
  font-size: 48px;
  color: #fff;
  font-weight: normal;
  padding-top: 105px;
}
.business .nei_ban p {
  font-size: 24px;
  color: #fff;
  text-transform: uppercase;
}
.business .clear {
  height: 0;
  clear: both;
  zoom: 1;
}
.business .ptb3 {
  padding-top: 3%;
}
.business .wrap {
  width: 1200px;
  margin: 0 auto;
}
.business .fwList ul li {
  width: 378px;
  text-align: center;
  height: 375px;
  position: relative;
  margin-bottom: 18px;
}

.business .fwList ul li img {
  width: 100%;
  height: 260px;
}
img {
  max-width: 100%;
}
img {
  border: none;
  display: inline-block;
}
.business .fwList ul li .fwtxt {
  overflow: hidden;
  background: #fff;
  padding-top: 32px;
}
.business .fwList ul li b {
  font-size: 18px;
  color: #333;
  display: inline-block;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  width: 90%;
  margin: 0 auto;
}
.business .fwList ul li span {
  display: block;
  width: 50px;
  height: 1px;
  background: #e6bf2a;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 40px;
}
.business .fwList ul li p {
  display: none;
  color: #999;
  width: 80%;
  margin: 0 auto;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  
}
a {
  text-decoration: none;
  /* display: inline-block; */
  color: #333;
  transition: all 0.25s;
}
.business .fwList ul li:nth-child(3n+2) {
  margin: 0px 33px;
}
.business .fwList ul li:hover {
  box-shadow: 0px 0px 10px 5px rgba(78,78,78,0.1);
}
.business .fwList ul li:hover .fwtxt {
  height: 200px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
}
.business .fwList ul li:hover .fwtxt b {
  color: #0062b1;
}
.business .fwList ul li:hover .fwtxt span {
  margin-bottom: 22px;
  background-color: #0062b1;
}
.business .fwList ul li:hover .fwtxt p {
  display: block;
}

@media (max-width: 1250px) {
.business .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
  .business .fwList ul li {
  width: 31%!important;
  margin: 0 1%;
}
  .business .fwList ul li:nth-child(3n+2) {
    margin: 0 1%;
} 
}
@media (max-width: 992px) {
.business .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.business .fwList ul li {
  width: 40%!important;
  margin: 0 5%;
}
.business .fwList ul li:nth-child(3n+2) {
  margin: 0 5%;
} 

}
@media (max-width: 768px) {
.business .wrap {
  width: 100% !important;
  padding: 0 15px;
  box-sizing: border-box;
}
.business .fwList ul li {
  width: 100%!important;
  margin: auto!important;
  float: none!important;
}
.business .fwList ul li:nth-child(3n+2) {
  margin: auto;
}
}
</style>